import React from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { Button, Table, Spinner } from 'react-bootstrap';
import { SearchAlt } from '@styled-icons/boxicons-regular/SearchAlt';

import { MoneyBill1 } from '@styled-icons/fa-regular/MoneyBill1';

//Actions
import { subitemselecionado } from '../../../../actions/produto/subitem';

//Components
import { campotexto } from '../../../../components/forms/campos/campos';
import FormProdutosPrecosLista from './FormProdutosPrecosLista';

//Helpers
import { TelaModalLivre } from '../../../../helpers/TelaModal';

class FormProdutosPrecos extends React.Component {

    state = {
        pesquisamodal: false
    }

    handleEditar = (item = {}) => {
        this.props.subitemselecionado(item);
        this.handleCloseModal();
    }

    handleCloseModal = () => {
        this.setState({
            pesquisamodal: !this.state.pesquisamodal?true:false
        })
    }
    
    render() {
        return (
            <>
            <TelaModalLivre show={this.state.pesquisamodal} handleCloseModal={this.handleCloseModal} titulo="Cadastro de Preços">
                <FormProdutosPrecosLista />
            </TelaModalLivre> 
            <Form
            onSubmit={this.props.handleSubmit}
            render={({ submitting, pristine, form, handleSubmit, submitSucceeded }) => (                
                <form onSubmit={handleSubmit}>
                    <Table striped bordered hover>
                        <thead>
                            <tr teste={console.log(submitSucceeded,this.props.pendingTasks===false,this.props.cadastros.length)}>
                                <th colSpan="2">Pesquisa Produtos</th>                                
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <Field type="text" name="portugues" component={campotexto} placeholder={this.props.placeholder} />
                                </td>                                
                                <td className="text-center">
                                    <Button type="submit">                                        
                                        {this.props.pendingTasks?
                                        <Spinner animation="border"  />
                                        :
                                        <SearchAlt size="30" disabled={pristine || submitting} />
                                        }
                                    </Button>
                                </td>
                            </tr>
                        </tbody>
                    </Table>                    
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                            <th>Produto</th>                            
                            <th>Editar Preços</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.cadastros.length?this.props.cadastros.map(itens => {
                                return (
                                    <tr key={itens.idsubitems}>
                                        <td>{itens.portugues}</td>
                                        <td className="text-center">
                                            <MoneyBill1 style={{cursor: "pointer"}} onClick={() => this.handleEditar(itens)} size="35" />
                                        </td>
                                    </tr>  
                                )
                            })
                            :
                            null
                            }                  
                        </tbody>
                    </Table>
                </form>
            )}
            />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {        
        pendingTasks: state.pendingTasks
    }
}

export default connect(mapStateToProps, { subitemselecionado })(FormProdutosPrecos);